import styled from "styled-components";
import ThemeColors from "../../../../../../themes/colors";

export const MainContainer = styled.div`
  display: flex;
  background-color: ${ThemeColors.Bg300};
  padding: 0.5rem 6rem;
  height: 0.75rem;
  border-radius: 0.65rem;
  align-items: center;
  position: relative;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  cursor: pointer;
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 2.5rem;
  left: 0;
  width: 100%;
  background-color: ${ThemeColors.Bg300};
  border-radius: 0.75rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  z-index: 2;
  max-height: 20rem;
  overflow: auto;
`;

export const DropdownItem = styled.div<{ isSelected: boolean }>`
  padding: 0.75rem;
  background-color: ${(props) =>
    props.isSelected ? ThemeColors.Bg2500 : ThemeColors.Bg300};
  transition: background-color ease 0.25s;
  cursor: pointer;

  &:hover {
    background-color: ${ThemeColors.Bg2500};
  }
`;
